<body>
    <div class="grid-overlay">
        <app-page-header></app-page-header>
        <div class="question-content">
            <h1 class="main-title">{{ 'faqsHovers.title' | translate }}</h1>
            <div class="faqs">
                <div class="header">
                    <div class="title">
                        <img src="../../assets/icons/informacion2.png" alt="icono de informacion">
                        <h1>{{ 'faqsHovers.section.title' | translate }}</h1>
                    </div>
                    <img src="../../assets/icons/cerrar.png" (click)="onCloseModal()" alt="cerrar el modal"
                        class="close">
                </div>
                <div class="question-grid">
                    <div class="left">
                        <div class="header-description">
                            <p>{{ 'faqsHovers.descriptions.headerSection.title' | translate }}</p>
                            <p>{{ 'faqsHovers.descriptions.headerSection.subtitle' | translate }}</p>
                            <p>{{ 'faqsHovers.descriptions.headerSection.cta' | translate }}</p>
                        </div>
                        <div class="plans-description">
                            <p>{{ 'faqsHovers.descriptions.plansSection.portalName' | translate }}</p>
                            <p>{{ 'faqsHovers.descriptions.plansSection.planNames' | translate }}</p>
                            <p>{{ 'faqsHovers.descriptions.plansSection.planImage' | translate }}</p>
                            <p>{{ 'faqsHovers.descriptions.plansSection.badge' | translate }}</p>
                            <p>{{ 'faqsHovers.descriptions.plansSection.price' | translate }}</p>
                            <p>{{ 'faqsHovers.descriptions.plansSection.frequency' | translate }}</p>
                            <p>{{ 'faqsHovers.descriptions.plansSection.planDescription' | translate }}</p>
                            <p>{{ 'faqsHovers.descriptions.plansSection.ctaSelector' | translate }}</p>
                        </div>
                        <div class="banner-description">
                            <p>{{ 'faqsHovers.descriptions.bannerSection.promotionalBanner' | translate }}</p>
                            <p>{{ 'faqsHovers.descriptions.bannerSection.promotionTitle' | translate }}</p>
                            <p>{{ 'faqsHovers.descriptions.bannerSection.cta' | translate }}</p>
                        </div>
                        <p>{{ 'faqsHovers.descriptions.directContact' | translate }}</p>
                    </div>
                    <div class="right">
                        <div class="sky-blue">
                            <div class="line-horizontal"></div>
                            <span class="line-text-horizontal"><p>{{ 'faqsHovers.templateInfo.width' | translate }}</p></span>
                            <div class="line-vertical"></div>
                            <span class="line-text-vertical"><p>{{ 'faqsHovers.templateInfo.height' | translate }}</p></span>
                            <div class="text">
                                <h1>{{ 'faqsHovers.templateInfo.mainText' | translate }}</h1>
                                <p>{{ 'faqsHovers.templateInfo.ctaText' | translate }}</p>
                            </div>
                        </div>
                        <div class="plans-section">
                            <div class="text">
                                <p>{{ 'faqsHovers.templateInfo.pricesTitle' | translate }}</p>
                                <h1>{{ 'faqsHovers.templateInfo.pricesSubtitle' | translate }}</h1>
                            </div>
                            <div class="plan-grid">
                                <div class="plan">
                                    <div class="preview">
                                        <div class="header">
                                            <h1>{{ 'faqsHovers.templateInfo.plan1' | translate }}</h1>
                                        </div>
                                        <div class="see-photo"></div>
                                        <h3>{{ 'faqsHovers.templateInfo.clubVip' | translate }}</h3>
                                        <h1 class="big-number">$0</h1>
                                        <h3>{{ 'faqsHovers.templateInfo.monthly' | translate }}</h3>
                                        <div class="including">
                                            <ul class="dotted-list">
                                                <li>{{ 'faqsHovers.templateInfo.includesTitle' | translate }}</li>
                                                <li>{{ 'faqsHovers.templateInfo.includesItem' | translate }}</li>
                                            </ul>
                                        </div>
                                        <div class="select">
                                            <button>{{ 'faqsHovers.templateInfo.selectButton' | translate }}</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="plan-info">
                                    <h1>{{ 'faqsHovers.templateInfo.planInfo' | translate }}</h1>
                                    <p>{{ 'faqsHovers.templateInfo.valueProposition' | translate }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="banner-section">
                            <div class="banner-grid">
                                <div class="left">
                                    <h1>
                                        {{ 'faqsHovers.templateInfo.bannerText' | translate }}
                                    </h1>
                                    <p>{{ 'faqsHovers.templateInfo.subtitle' | translate }}</p>
                                </div>
                                <div class="right">
                                    <p>{{ 'faqsHovers.templateInfo.imageDescription' | translate }}</p>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="mail">
                            <img src="../../../assets/icons/mail.png" alt="icono de mail">
                            <h2>Forma&#64;<strong>decontacto.com</strong></h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="options-buttons">
            <button class="back-btn">{{ 'faqsHovers.buttons.back' | translate }}</button>
            <button class="continue-btn">{{ 'faqsHovers.buttons.continue' | translate }}</button>
        </div>
        <div class="contact-us">
            <p>{{ 'faqsHovers.contact.question' | translate }}</p>
            <button>{{ 'faqsHovers.contact.button' | translate }}</button>
        </div>
    </div>
</body>